import React from "react";
import "./App.css";
import Header from "./components/Header/Header";
import Main from "./components/Main/Main";
import Servicos from "./components/Servicos/Servicos";
import Solucoes from "./components/Solucoes/Solucoes";
import Logos from "./components/Logos/Logos";
import Google from "./components/Google/Google";
import Alerta from "./components/Alerta/Alerta";
import Desenvolvimento from "./components/Desenvolvimento/Desenvolvimento";
import Projetos from "./components/Projetos/Projetos";
import Loretechls from "./components/Loretechls/Loretechls";
import Duvidas from "./components/Duvidas/Duvidas";
import SobreNos from "./components/SobreNos/SobreNos";
import Logos2 from "./components/Logos2/Logos2";
import Footer from "./components/Footer/Footer";
function App() {
  return (
    <>
      <Header />
      <Main />
      <Servicos />
      <Solucoes />
      <Logos />
      <Google />
      <Alerta />
      <Desenvolvimento />
      <Projetos />
      <Loretechls />
      <Duvidas />
      <SobreNos />
      <Logos2 />
      <Footer />
    </>
  );
}

export default App;
